import React, {useState} from 'react';
import _ from 'lodash';
import {Button, Form, Dimmer, Loader} from 'semantic-ui-react';
import {ContentDispatch} from 'framework';
import {connectWithCore} from 'framework/hocs';
import REST from 'go/requests/rest';
import {connect} from 'react-redux';
import {CLEAR_ALL_MSG} from 'common/types';
import DATA_FILTERS from 'go/components/common/dataFilters';
import {checkActivityCompleted} from 'common/utils';
import {ACTIVITY_RESPONSES} from 'app-ui-componentlibrary/dist/common/constants';

export const DynamicWorkflowTask = ({
  modalHeader,
  createBtnLabel,
  data,
  contents,
  validationErrors,
  validationDirtyMap,
  variables,
  workflowMessageName,
  messageActivityId,
  confirmModal,
  successMessage,
  clearAllMsg,
  entityDataPath,
  saveEntitySessionData,
  activityToWaitFor,
  ...restProps
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleWorkflowTaskSubmit = () => {
    let payloadVars = {};
    const lookupData = {...restProps, ...data};
    _.each(variables, (value, key) => {
      payloadVars[key] = _.get(lookupData, value, value);
    });
    const payload = {
      workflowMessageName: workflowMessageName,
      variables: payloadVars,
    };

    setIsLoading(true);
    REST.workflow
      .sendMessage(messageActivityId, payload)
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (activityToWaitFor) {
          const maxTimeout = 120000;
          checkActivityCompleted({
            token: _.get(restProps, 'token'),
            processInstanceId: _.get(restProps, 'processInstanceId'),
            activityId: activityToWaitFor,
            activityResponse: ACTIVITY_RESPONSES.ended,
            callback: () => {
              handlePostCallSave(lookupData);
            },
            maxTimeout: maxTimeout,
            activityMaxCount: _.get(restProps, 'activityMaxCount', 0) + 1,
          });
        } else {         
          setTimeout(()=>handlePostCallSave(lookupData),3000);  
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error('err');
      });
  };

  const handlePostCallSave = async (data) => {
    clearAllMsg();
    entityDataPath && saveEntitySessionData(`${entityDataPath}.submitted`, true);
    if (restProps.postCallSave) {
      await DATA_FILTERS[restProps.postCallSave]({saveEntitySessionData, ...data});
    }
    confirmModal(successMessage);
    setIsLoading(false);
  };

  const isValid = () => {
    let returnVal = true;
    _.forEach(validationErrors, (validation) => {
      let innerIsValid = true;
      _.forEach(validation, (innerValidation) => {
        if (!innerValidation.isValid) {
          innerIsValid = false;
        }
      });

      if (!innerIsValid) returnVal = false;
    });
    return !returnVal;
  };

  return (
    <Form>
      <h3>{modalHeader}</h3>
      <>
        {contents &&
          contents.map((entry, index) => {
            return <ContentDispatch config={entry} key={entry.title} />;
          })}
        {isLoading && (
          <Dimmer active page>
            <Loader>{restProps.loadingMessage}</Loader>
          </Dimmer>
        )}
      </>
      <div>
        <Button
          primary
          title={createBtnLabel}
          id="enterBtn"
          type="button"
          disabled={isValid()}
          onClick={handleWorkflowTaskSubmit}
        >
          {createBtnLabel}
        </Button>
      </div>
    </Form>
  );
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    clearAllMsg: () => {
      dispatch({type: CLEAR_ALL_MSG});
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectWithCore(DynamicWorkflowTask));
